<template>
  <div :class="b({ disabled: isDisabled })" @click="onClickLabel">
    <span :class="b('radio-input')">
      <input
        :value="name"
        v-model="currentValue"
        type="radio"
        :class="b('control')"
        :disabled="isDisabled"
      >
      <icon :class="b(currentValue === name ? 'om-icon-checked' : 'om-icon-normal')"
        name='circle-o' />
        <!-- "currentValue === name ? 'dot-circle-o' :  -->
    </span>
    <span v-if="$slots.default" :class="b('radio-label')">
      <slot />
    </span>
  </div>
</template>

<script>
import create from '../utils/create';
import findParent from '../mixins/find-parent';

export default create({
  name: 'radio',

  mixins: [findParent],

  props: {
    name: null,
    value: null,
    disabled: Boolean
  },

  computed: {
    currentValue: {
      get() {
        return this.parent ? this.parent.value : this.value;
      },

      set(val) {
        (this.parent || this).$emit('input', val);
      }
    },

    isDisabled() {
      return this.parent
        ? this.parent.disabled || this.disabled
        : this.disabled;
    }
  },

  created() {
    this.findParent('om-radio-group');
  },

  methods: {
    onClickLabel() {
      if (!this.isDisabled) {
        this.currentValue = this.name;
      }
      this.$emit('click')
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/radio/index.vue